// src/routes/notificationTemplatesRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';

import NotificationTemplates from '../pages/notificationTemplates/NotificationTemplates';
import CreateNotificationTemplate from '../pages/notificationTemplates/CreateNotificationTemplate';
import EditNotificationTemplate from '../pages/notificationTemplates/EditNotificationTemplate';
import ProtectedRoute from '../components/global/ProtectedRoute';

const notificationTemplatesRoutes = (
    <>
        <Route
            path="/settings/notifications"
            element={
                <ProtectedRoute requiredPermission="notifications.manage">
                    <NotificationTemplates />
                </ProtectedRoute>
            }
        />
        <Route
            path="/settings/notifications/create"
            element={
                <ProtectedRoute requiredPermission="notifications.manage">
                    <CreateNotificationTemplate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/settings/notifications/:id/edit"
            element={
                <ProtectedRoute requiredPermission="notifications.manage">
                    <EditNotificationTemplate />
                </ProtectedRoute>
            }
        />
    </>
);

export default notificationTemplatesRoutes;
